import { render, staticRenderFns } from "./dentistryFour.vue?vue&type=template&id=c05d1e36&scoped=true"
import script from "./dentistryFour.vue?vue&type=script&lang=js"
export * from "./dentistryFour.vue?vue&type=script&lang=js"
import style0 from "./dentistryFour.vue?vue&type=style&index=0&id=c05d1e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05d1e36",
  null
  
)

export default component.exports